import { REACTIONS_DICT } from './constants';
export function updateMessageReactions(reactionId, userId, reactionsObj) {
  const updatedReactions = reactionsObj ? { ...reactionsObj } : {};
  updatedReactions[userId] = Number(reactionId);

  return updatedReactions;
}

export function getReactionsTotals(reactions) {
  if (!reactions) {
    return {};
  }

  return Object.keys(reactions).reduce((total, uId) => {
    const count = total[reactions[uId]];
    total[reactions[uId]] = count ? count + 1 : 1;
    return total;
  }, {});
}

export function getReactionUsers(reactionId, reactions) {
  if (!reactions) {
    return [];
  }

  return Object.keys(reactions).reduce((users, uId) => {
    if (String(reactionId) === String(reactions[uId])) {
      users.push({ id: Number(uId) });
    }
    return users;
  }, []);
}

export function getReactionsToDisplay(reactions) {
  const totals = getReactionsTotals(reactions);

  return Object.keys(totals)
    .filter((rId) => REACTIONS_DICT[rId]?.emoji && totals[rId] > 0)
    .map((rId) => ({ ...REACTIONS_DICT[rId], rId: Number(rId), total: totals[rId] }));
}

export function getSortedReactionsArray() {
  const entries = Object.entries(REACTIONS_DICT);
  const dict = entries.reduce((acc, [key, value]) => {
    acc.push({ id: key, ...value });
    return acc;
  }, []);
  return dict.sort((a, b) => a.order - b.order);
}
